module.exports = __webpack_public_path__ + "img/ch18_10_夜问月亮.11a1b8f6.jpg";